import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { FileUpload } from 'primereact/fileupload';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useRef, useState } from 'react';
import slugify from 'react-slugify';
import FormInput from '../../../../components/Form/FormInput';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useToastContext } from '../../../../contexts/ToastContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import { computeImageShape } from '../../../../utils/imageHelper';
import ImageItem from './ImageItem';

function ImageForm({
  image,
  setImage,
  deleteImage,
  ratio,
  label = 'Photo principale (max. 10Mo)',
  required = true,
  imageTargetRef
}) {
  const { accountContext } = useAccountContext();
  const [imageLoading, setImageLoading] = useState(false);
  const fileUploadRef = useRef(null);
  const { showToast } = useToastContext();
  const [imageIsValid, setImageIsValid] = useState(true);

  const uploadImage = async (imageForm) => {
    await privateFetch(
      'POST',
      'resources',
      `/cu/${accountContext.id}/image/`,
      "L'image a bien été ajoutée",
      imageForm,
      false,
      true
    ).then((res) => {
      setImage(res);
    });
    setImageLoading(false);
  };

  const onUpload = (event) => {
    if (event.files[0].size > CONSTANT.maxImageSize) {
      showToast('warn', '10Mo max.');
      onClear();
    } else {
      setImageLoading(true);

      const file = event.files[0];
      const imageForm = new FormData();
      imageForm.append('title', slugify(file.title));
      imageForm.append('file', file);
      uploadImage(imageForm);
    }
  };

  const onClear = () => {
    deleteImage();
    fileUploadRef.current.clear();
  };

  const handleImageLoad = (event) => {
    const isValid = computeImageShape(event, ratio);
    setImageIsValid(isValid);
  };

  return (
    <div className="h-fit" ref={imageTargetRef}>
      <FormInput key={'file'} label={label} required={required} isValid={image}>
        {image && (
          <ImageItem
            imageMode
            className={'max-w-[400px] max-h-[400px] object-contain object-left mb-5'}
            image={image}
            imageLoad={ratio && handleImageLoad}
          />
        )}
        {!imageIsValid && image && ratio && (
          <Message
            severity="error"
            text={`Cette image n'a pas le bon ratio (${ratio}:1) l'affichage sur le site vitrine ne sera optimal.`}
            className="mb-5"
          />
        )}
        <div className="flex flex-row gap-x-3">
          {image && (
            <Button
              key={'delete-img'}
              label={"Supprimer l'image"}
              outlined
              onClick={onClear}
              severity="danger"
            />
          )}
          {imageLoading ? (
            <div className="w-[50px] h-[50px] p-1">
              <ProgressSpinner style={{ width: '42px', height: '42px' }} />
            </div>
          ) : (
            <FileUpload
              ref={fileUploadRef}
              auto
              disabled={image}
              mode="basic"
              title="file"
              accept="image/*"
              customUpload
              uploadHandler={onUpload}
              chooseLabel="Depuis mon ordinateur"
            />
          )}
        </div>
      </FormInput>
      <Divider />
    </div>
  );
}

export default ImageForm;
